import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppLanguages } from 'src/app/core/models/models';

@Injectable({ providedIn: 'root' })
export class LocaleService {
  private _locale: string;

  constructor(private translate: TranslateService) {}

  set locale(value: string) {
    this._locale = value;
  }

  get locale(): string {
    return this.translate.currentLang || AppLanguages.english;
  }

  getLocale(): string {
    return this._locale || AppLanguages.english;
  }

  public registerCulture(culture: string) {
    if (!culture) {
      return;
    }
    switch (culture) {
      case '': {
        this._locale = AppLanguages.spanishMexican;
        break;
      }
      case AppLanguages.english: {
        this._locale = AppLanguages.english;
        break;
      }
      case AppLanguages.spanish: {
        this._locale = AppLanguages.spanish;
        break;
      }
      case AppLanguages.spanishMexican: {
        this._locale = AppLanguages.spanish;
        break;
      }
      case AppLanguages.portuguese: {
        this._locale = AppLanguages.portuguese;
        break;
      }
      default: {
        this._locale = AppLanguages.english;
        break;
      }
    }
  }
}
